import React from 'react';
import SvgIcon from './SvgIcon';

const SavedAlertsEmpty = props => (
    <SvgIcon viewBox="0 0 211 187" {...props}>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="1.0.1---Incidents---Empty-State" transform="translate(-534.000000, -244.000000)">
                <g id="empty" transform="translate(450.000000, 244.968504)">
                    <g id="saved-alerts-empty" transform="translate(85.000000, 0.000000)">
                        <circle id="Oval" fill="#EEF6FF" fillRule="nonzero" cx="101" cy="93.0314961" r="93"></circle>
                        <ellipse
                            id="Oval"
                            fill="#3777BC"
                            fillRule="nonzero"
                            opacity="0.504"
                            cx="169.243598"
                            cy="175.942291"
                            rx="3.10186614"
                            ry="3.09189764"
                        ></ellipse>
                        <ellipse
                            id="Oval"
                            fill="#3777BC"
                            fillRule="nonzero"
                            opacity="0.28"
                            cx="115.601417"
                            cy="19.2839291"
                            rx="5.94787402"
                            ry="5.92959843"
                        ></ellipse>
                        <ellipse
                            id="Oval"
                            fill="#3777BC"
                            fillRule="nonzero"
                            cx="169.745346"
                            cy="78.4552362"
                            rx="1.94219685"
                            ry="1.93555118"
                        ></ellipse>
                        <ellipse
                            id="Oval"
                            fill="#3777BC"
                            fillRule="nonzero"
                            cx="30.0151654"
                            cy="81.5223543"
                            rx="3.65844094"
                            ry="3.64681102"
                        ></ellipse>
                        <g
                            id="Group"
                            transform="translate(152.787402, 0.000000)"
                            stroke="#3777BC"
                            strokeWidth="1.15634646"
                        >
                            <polygon
                                id="Path"
                                points="5.42452756 16.8700315 12.6982126 4.53899213 18.0180709 13.6252835 3.47070079 13.6252835 8.89855118 4.53899213 16.0642441 16.8700315"
                            ></polygon>
                            <ellipse
                                id="Oval"
                                cx="10.7443858"
                                cy="10.7045118"
                                rx="10.7443858"
                                ry="10.7045118"
                            ></ellipse>
                        </g>
                        <g
                            id="Group"
                            transform="translate(0.000000, 24.952756)"
                            stroke="#3777BC"
                            strokeWidth="1.04004724"
                        >
                            <polygon
                                id="Path"
                                points="4.48084252 13.9359685 10.4885276 3.7498189 14.8829764 11.2544409 2.86594488 11.2544409 7.35011024 3.7498189 13.2697402 13.9359685"
                            ></polygon>
                            <ellipse
                                id="Oval"
                                cx="8.87529134"
                                cy="8.84206299"
                                rx="8.87529134"
                                ry="8.84206299"
                            ></ellipse>
                        </g>
                        <g
                            id="Group"
                            transform="translate(29.874016, 161.220472)"
                            stroke="#3777BC"
                            strokeWidth="0.867259843"
                        >
                            <polygon
                                id="Path"
                                points="4.34792913 13.5222756 10.1778425 3.63850394 14.4427008 10.9221575 2.7812126 10.9221575 7.13246457 3.63850394 12.8759843 13.5222756"
                            ></polygon>
                            <ellipse id="Oval" cx="8.6127874" cy="8.58122047" rx="8.6127874" ry="8.58122047"></ellipse>
                        </g>
                        <ellipse
                            id="Oval"
                            fill="#D8D8D8"
                            fillRule="nonzero"
                            cx="207.957945"
                            cy="106.636339"
                            rx="1.94219685"
                            ry="1.93555118"
                        ></ellipse>
                        <g id="list" transform="translate(64.000000, 48.031496)" fillRule="nonzero">
                            <path
                                d="M72.0526316,0 L1.94736842,0 C0.872421053,0 0,0.876521739 0,1.95652174 L0,88.0434783 C0,89.1234783 0.872421053,90 1.94736842,90 L72.0526316,90 C73.1275789,90 74,89.1234783 74,88.0434783 L74,1.95652174 C74,0.876521739 73.1275789,0 72.0526316,0 Z"
                                id="Path"
                                fill="#A4C3E4"
                            ></path>
                            <path
                                d="M58.4210526,54.7826087 L29.2105263,54.7826087 C28.1355789,54.7826087 27.2631579,53.906087 27.2631579,52.826087 C27.2631579,51.746087 28.1355789,50.8695652 29.2105263,50.8695652 L58.4210526,50.8695652 C59.496,50.8695652 60.3684211,51.746087 60.3684211,52.826087 C60.3684211,53.906087 59.496,54.7826087 58.4210526,54.7826087 Z"
                                id="Path"
                                fill="#3777BC"
                            ></path>
                            <path
                                d="M46.7368421,70.4347826 L29.2105263,70.4347826 C28.1355789,70.4347826 27.2631579,69.5582609 27.2631579,68.4782609 C27.2631579,67.3982609 28.1355789,66.5217391 29.2105263,66.5217391 L46.7368421,66.5217391 C47.8117895,66.5217391 48.6842105,67.3982609 48.6842105,68.4782609 C48.6842105,69.5582609 47.8117895,70.4347826 46.7368421,70.4347826 Z"
                                id="Path"
                                fill="#3777BC"
                            ></path>
                            <path
                                d="M50.6315789,39.1304348 L29.2105263,39.1304348 C28.1355789,39.1304348 27.2631579,38.253913 27.2631579,37.173913 C27.2631579,36.093913 28.1355789,35.2173913 29.2105263,35.2173913 L50.6315789,35.2173913 C51.7065263,35.2173913 52.5789474,36.093913 52.5789474,37.173913 C52.5789474,38.253913 51.7065263,39.1304348 50.6315789,39.1304348 Z"
                                id="Path"
                                fill="#3777BC"
                            ></path>
                            <path
                                d="M58.4210526,23.4782609 L29.2105263,23.4782609 C28.1355789,23.4782609 27.2631579,22.6017391 27.2631579,21.5217391 C27.2631579,20.4417391 28.1355789,19.5652174 29.2105263,19.5652174 L58.4210526,19.5652174 C59.496,19.5652174 60.3684211,20.4417391 60.3684211,21.5217391 C60.3684211,22.6017391 59.496,23.4782609 58.4210526,23.4782609 Z"
                                id="Path"
                                fill="#3777BC"
                            ></path>
                            <path
                                d="M17.5263158,41.0869565 C15.3783684,41.0869565 13.6315789,39.3319565 13.6315789,37.173913 C13.6315789,35.0158696 15.3783684,33.2608696 17.5263158,33.2608696 C19.6742632,33.2608696 21.4210526,35.0158696 21.4210526,37.173913 C21.4210526,39.3319565 19.6742632,41.0869565 17.5263158,41.0869565 Z"
                                id="Path"
                                fill="#6EA1D7"
                            ></path>
                            <path
                                d="M17.5263158,56.7391304 C15.3783684,56.7391304 13.6315789,54.9841304 13.6315789,52.826087 C13.6315789,50.6680435 15.3783684,48.9130435 17.5263158,48.9130435 C19.6742632,48.9130435 21.4210526,50.6680435 21.4210526,52.826087 C21.4210526,54.9841304 19.6742632,56.7391304 17.5263158,56.7391304 Z"
                                id="Path"
                                fill="#6EA1D7"
                            ></path>
                            <path
                                d="M17.5263158,72.3913043 C15.3783684,72.3913043 13.6315789,70.6363043 13.6315789,68.4782609 C13.6315789,66.3202174 15.3783684,64.5652174 17.5263158,64.5652174 C19.6742632,64.5652174 21.4210526,66.3202174 21.4210526,68.4782609 C21.4210526,70.6363043 19.6742632,72.3913043 17.5263158,72.3913043 Z"
                                id="Path"
                                fill="#6EA1D7"
                            ></path>
                            <path
                                d="M17.5263158,25.4347826 C15.3783684,25.4347826 13.6315789,23.6797826 13.6315789,21.5217391 C13.6315789,19.3636957 15.3783684,17.6086957 17.5263158,17.6086957 C19.6742632,17.6086957 21.4210526,19.3636957 21.4210526,21.5217391 C21.4210526,23.6797826 19.6742632,25.4347826 17.5263158,25.4347826 Z"
                                id="Path"
                                fill="#6EA1D7"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

SavedAlertsEmpty.displayName = 'SavedAlertsEmptyIcon';

export default SavedAlertsEmpty;
